<template>
  <div>
    <b-modal
      hide-footer
      hide-backdrop
      no-close-on-esc
      title="Applicable Offers"
      ref="promoOffersPopup"
      id="promoOffersPopup"
      size="lg"
      centered
    >
      <div class="applicable-offer-wrapper">
        <ul
          v-if="getOffersCollection && getOffersCollection.length > 0"
          class="pos-applicable-offers-list"
        >
          <li
            class
            v-for="(OffersItem, OffersIndex) in getOffersCollection"
            v-if="checkOfferType(OffersItem)"
            :key="OffersIndex"
            style="padding: 7px"
          >
            <div
              name="applicableOffers"
              v-model="ApplicableOfferSelected"
              class="j-radio w-75"
            >
              <div v-if="String(OffersItem.offer_type_id) === '1'">
                <strong>{{
                  OffersItem.offer_title || OffersItem.offer_code
                }}</strong>
                <br />
                Buy {{ OffersItem.oc_buy_no_of_ticket }} Tickets Get
                {{ OffersItem.oc_get_free_ticket }} Tickets Free
              </div>
              <div v-else-if="String(OffersItem.offer_type_id) === '2'">
                <strong>{{
                  OffersItem.offer_title || OffersItem.offer_code
                }}</strong>
                <br />
                Buy {{ OffersItem.oc_buy_no_of_ticket }}
                {{
                  OffersItem.offer_redeem_at_concession == "Y"
                    ? "Tickets/Items"
                    : "Tickets"
                }}
                &amp; Get Flat {{ OffersItem.oc_discount_value }}
                {{
                  OffersItem.oc_discount_value_is_percentage === "Y"
                    ? "%"
                    : currencyData["curr_code"]
                }}
                OFF.
              </div>
              <div v-else-if="String(OffersItem.offer_type_id) === '3'">
                <strong>{{
                  OffersItem.offer_title || OffersItem.offer_code
                }}</strong>
                <br />
                Combo Offers
              </div>
              <div v-else-if="String(OffersItem.offer_type_id) === '4'">
                <strong>{{
                  OffersItem.offer_title || OffersItem.offer_code
                }}</strong>
                <br />
                {{ OffersItem.buc_category_name }} Offers
              </div>
              <div v-else-if="String(OffersItem.offer_type_id) === '5'">
                <strong>{{
                  OffersItem.offer_title || OffersItem.offer_code
                }}</strong>
                <br />
                Bank Offers
              </div>
              <div v-else-if="String(OffersItem.offer_type_id) === '6'">
                <strong>{{
                  OffersItem.offer_title || OffersItem.offer_code
                }}</strong>
                <br />
                Promo code Offers
              </div>
              <div v-else-if="String(OffersItem.offer_type_id) === '7'">
                <strong>{{
                  OffersItem.offer_title || OffersItem.offer_code
                }}</strong>
                <br />
                Buy {{ OffersItem.oc_buy_no_of_ticket }}
                {{
                  OffersItem.offer_redeem_at_concession == "Y"
                    ? "Tickets/Items"
                    : "Tickets"
                }}
                &amp; Get Flat {{ OffersItem.oc_discount_value }}
                {{
                  OffersItem.oc_discount_value_is_percentage === "Y"
                    ? "%"
                    : currencyData["curr_code"]
                }}
                OFF.&nbsp;Only for Loyality Members
              </div>
              <div v-else-if="String(OffersItem.offer_type_id) === '8'">
                <strong>{{
                  OffersItem.offer_title || OffersItem.offer_code
                }}</strong>
                <br />
                Get Flat {{ OffersItem.oc_discount_value }}
                {{
                  OffersItem.oc_discount_value_is_percentage === "Y"
                    ? "%"
                    : currencyData["curr_code"]
                }}
                OFF
              </div>

              <div v-else-if="String(OffersItem.offer_type_id) === '9'">
                <strong>{{
                  OffersItem.offer_title || OffersItem.offer_code
                }}</strong>
                <br />
                {{getOfferDescription(OffersItem)}}
              </div>

              <div v-else-if="OffersItem.offer_type_id == '10'">
                      <strong>{{
                        OffersItem.offer_title || OffersItem.offer_code
                      }}</strong>
                       <br />
                {{getOfferDescription(OffersItem)}}
                    </div>

              <div v-else>
                <strong>{{
                  OffersItem.offer_title || OffersItem.offer_code
                }}</strong>
                Not Available
              </div>
            </div>

            <!-- @click="onApplyOffer(OffersItem)" -->
            <button
              v-if="String(OffersItem.offer_type_id) == '7' && !cust_id"
              class="btn-blue"
              @click="onClickAddCustomer(OffersItem)"
            >
              + Add
            </button>
            <button
              v-else
              @click="onclickApplyOffer(OffersItem)"
              class="btn-blue"
            >
              Apply
            </button>
            <button
              v-b-toggle="'offer-details-' + OffersItem.os_id"
              class="btn-transparent"
            >
              <small>Show Details</small>
            </button>

            <b-collapse :id="'offer-details-' + OffersItem.os_id">
              <ul
                v-if="String(OffersItem.offer_type_id) === '1'"
                class="small pt-3"
              >
                <li class="py-1">
                  Minimun Ticket Price:
                  {{ OffersItem.oc_min_ticket_price }}
                </li>
                <li class="py-1">
                  Maximum Free Tickets Per Transactions:
                  {{ OffersItem.oc_max_no_of_ticket_per_transaction }}
                </li>
              </ul>
              <ul
                v-else-if="
                  String(OffersItem.offer_type_id) === '2' ||
                    String(OffersItem.offer_type_id) === '8'
                "
                class="small pt-3"
              >
                <li class="py-1">
                  Maximum discount per transaction:
                  {{ OffersItem.oc_max_discount_amount }}
                </li>
                <!-- <li class="py-1">Maximum Free Tickets Per Transactions: {{ OffersItem.oc_max_no_of_ticket_per_transaction }}</li> -->
              </ul>
              <ul
                v-else-if="String(OffersItem.offer_type_id) === '3'"
                class="small pt-3"
              >
                <li class="py-1">
                  Offer Combine With:
                  {{
                    OffersItem.oc_is_combo_with_fnb === "Y"
                      ? "F&B"
                      : "BoxOffice"
                  }}
                </li>
                <li class="py-1" v-if="OffersItem.oc_is_combo_with_fnb === 'Y'">
                  Buy {{ OffersItem.oc_buy_item_count }}
                  {{ OffersItem.buy_item_name }} F&amp;B Item &amp; Get
                  {{ OffersItem.oc_get_item_count }}
                  {{ OffersItem.get_item_name }} F&amp;B Item
                  <span v-if="OffersItem.oc_is_combo_free === 'Y'">{{
                    "Is Free"
                  }}</span>
                  <span v-if="OffersItem.oc_is_combo_free === 'N'"
                    >{{ OffersItem.oc_discount_value }}
                    {{
                      OffersItem.oc_discount_value_is_percentage === "Y"
                        ? "% OFF"
                        : `${currencyData["curr_code"]} OFF`
                    }}</span
                  >
                </li>
                <li class="py-1" v-if="OffersItem.oc_is_combo_with_fnb === 'N'">
                  Buy Tickets {{ OffersItem.oc_buy_no_of_ticket }} &amp; Get
                  F&amp;B Item {{ OffersItem.get_item_name }}
                  <span v-if="OffersItem.oc_is_combo_free === 'Y'">{{
                    "Is Free"
                  }}</span>
                  <span v-if="OffersItem.oc_is_combo_free === 'N'"
                    >{{ OffersItem.oc_discount_value }}
                    {{
                      OffersItem.oc_discount_value_is_percentage === "Y"
                        ? "% OFF"
                        : `${currencyData["curr_code"]} OFF`
                    }}</span
                  >
                </li>
              </ul>
              <ul
                v-else-if="String(OffersItem.offer_type_id) === '4'"
                class="small pt-3"
              >
                <li class="py-1">
                  Minimun Ticket Price:
                  {{ OffersItem.cco_min_ticket_amount }}
                </li>
                <li class="py-1">
                  Maximum discount per transaction:
                  {{ OffersItem.cco_max_discount_amount }}
                </li>
                <li class="py-1">
                  Offer Price: {{ OffersItem.cco_offer_value }}
                  {{
                    OffersItem.cco_offer_value_is_percentage === "Y"
                      ? "%"
                      : currencyData["curr_code"]
                  }}
                </li>
                <li class="py-1">
                  Special Instruction:
                  <br />
                  <span v-html="OffersItem.cco_instruction"></span>
                </li>
              </ul>
              <ul
                v-else-if="String(OffersItem.offer_type_id) === '5'"
                class="small pt-3"
              >
                <div class="mb-3">
                  <div class="d-flex align-items-center w-75">
                    <div class="input-material">
                      <input
                        @input="updateCardNumber"
                        name="card_number"
                        id="card_number"
                        placeholder="."
                        v-validate="'numeric|min:12|max:12'"
                        type="text"
                      />
                      <label>Card Number</label>
                    </div>
                  </div>
                </div>
                <li class="py-1">Bank Name: {{ OffersItem.bank_name }}</li>
                <li class="py-1">Bank Card: {{ OffersItem.card_type }}</li>
                <li class="py-1" v-if="OffersItem.bo_weekly_redemption">
                  {{ "Weekly" }} Redemption:
                  {{ OffersItem.bo_weekly_redemption }}
                </li>
                <li class="py-1" v-if="OffersItem.bo_monthly_redemption">
                  {{ "Monthly" }} Redemption:
                  {{ OffersItem.bo_monthly_redemption }}
                </li>
                <li class="py-1" v-if="OffersItem.bo_yearly_redemption">
                  {{ "Yearly" }} Redemption:
                  {{ OffersItem.bo_yearly_redemption }}
                </li>
                <li class="py-1">
                  Offer Price: {{ OffersItem.bo_offer_value }}
                  {{
                    OffersItem.bo_offer_value_is_percentage === "Y"
                      ? "%"
                      : currencyData["curr_code"]
                  }}
                </li>
                <li class="py-1">
                  Special Instruction:
                  <br />
                  <span v-html="OffersItem.bo_instruction"></span>
                </li>
              </ul>
              <ul
                v-else-if="String(OffersItem.offer_type_id) === '6'"
                class="small pt-3"
              >
                <li class="py-1">
                  Promo Code: {{ OffersItem.promo_code }} applicable for
                  {{
                    OffersItem.pcs_no_of_transactions
                      ? OffersItem.pcs_no_of_transactions
                      : "N/A"
                  }}
                  Transactions
                </li>
                <input
                  placeholder="."
                  type="text"
                  :value="promoCode"
                  @input="
                    onEnterPromoCodes({
                      event: $event,
                      name: 'enterPromoCode'
                    })
                  "
                  name="promocode"
                  id="promocode"
                />
                <!-- v-model="promocode" -->
                <li class="py-1">
                  Categories: {{ OffersItem.booking_user_category_id }}
                </li>
                <li class="py-1">
                  Minimun Ticket Price:
                  {{ OffersItem.pcs_min_ticket_amount }}
                </li>
                <li class="py-1">
                  Maximum discount per transaction:
                  {{ OffersItem.pcs_max_discount_amount }}
                </li>
                <li class="py-1">
                  Offer Price: {{ OffersItem.pcs_offer_value }}
                  {{
                    OffersItem.pcs_offer_value_is_percentage === "Y"
                      ? "%"
                      : currencyData["curr_code"]
                  }}
                </li>
                <li class="py-1">
                  Special Instruction:
                  <br />
                  <span v-html="OffersItem.pcs_instruction"></span>
                </li>
              </ul>
              <ul
                v-else-if="[9,10].includes(OffersItem.offer_type_id)"
                class="small pt-3"
              >
                <li class="py-1">
                  {{getOfferDescription(OffersItem, true)}}
                </li>
                <li class="py-1" v-if="OffersItem.pcs_instruction">
                  Special Instruction:
                  <br />
                  <span v-html="OffersItem.pcs_instruction"></span>
                </li>
              </ul>
              <ul v-else class="small pt-3">
                <li class="py-1"></li>
              </ul>
            </b-collapse>
          </li>
        </ul>
        <ul v-else>
          <li>
            <div>No Offers Found</div>
          </li>
        </ul>
      </div>
    </b-modal>
    <AddCustomerDetailsPopup
      modalId="addcustmodal1"
      :getCallback="onCallback"
    />

     <ManagerAuthLogin
      :moduleName="'posOfferAuth'"
      :onCheckAuth="onCheckAuthentication"
      :refId="'posOfferAuth'"
    />
     <AddEmployeeDiscountDetails :moduleName="'promoOfferPopUp'" :refId="'addEmployeeDetails'" :onCheckEmployeeDetails="onCheckEmployeeDetails"/>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService.js";
import UserService from "@/services/UserService.js";
import PosService from "@/services/PosService.js";
import { mapState, mapGetters, mapActions } from "vuex";
import languages from "@/helper/Languages";
import i18n from "@/plugins/i18n";
import { BASEURL } from "@/config/index.js";
import Nav from "@/NavHybrid";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import AddCustomerDetailsPopup from "@/components/Partials/AddCustomerDetailsPopup";
import { EventBus } from "@/main";
import _ from "lodash";
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
import AddEmployeeDiscountDetails from "@/components/Partials/AddEmployeeDiscountDetails";

export default {
  props: {
    type: {
      type: String,
      default: ""
    }
  },
  components: {
    Vkeyboard,
    VkeyboardFloat,
    AddCustomerDetailsPopup,
    ManagerAuthLogin,
    AddEmployeeDiscountDetails
  },
  data() {
    return {
      tempSelectedOffer: null,
      selectOffer: "",
      employeeDetailsAuth: false,
      ApplicableOfferSelected: false,
      keyboardsVisible: {
        showFirstNameKeyboard: false,
        showLastNameKeyboard: false,
        showEmailKeyboard: false
      },
      currencyData: {
        curr_code: ""
      },
      submitted: false
    };
  },
  computed: {
    ...mapGetters([
      "getSelectedOffer",
      "showViewOffers",
      "getOffersCollection",
      "getOfferPrice",
      "getSelectedOffer",
      "getOffersVoucherCollection",
      "getOfferFor",
      "paymentModes",
      "selectedPaymentMode",
      "getAvailablePoints",
      "getCustomerDetails"
    ]),
    cust_id() {
      return this.$store.getters.cust_id;
    }
  },
  beforeMount() {
    this.getCurrencyCode();
  },
  mounted() {
    console.log("this.type", this.type);
    EventBus.$on("callback_updateCustomerData", (data) => {
      console.log('callback_updateCustomerData CALLING inside promo', data);
      this.onclickApplyOffer(this.selectOffer);
    });
  },
  methods: {
    ...mapActions([
      "fetchOffersList",
      "applyOffersHandler",
      "applyBoxOfficeFnbOffersHandler",
      "applyFnbOffersHandler",
      "onSetSelectedOfferId",
      "onResetEmployeeDetails",
    ]),
     onCheckAuthentication(response) {
        const { valid, name, user_id } = response;
        if (valid) {
          if (name == "posOfferAuth") {
            this.$bvModal.hide("posOfferAuth");
            this.$bvModal.show('addEmployeeDetails')
          }
        }
      },
     onCheckEmployeeDetails(response) {
        const { valid, name } = response;
        if (valid) {
          if (name == "promoOfferPopUp") {
            this.employeeDetailsAuth = true;
            this.$bvModal.hide("addEmployeeDetails");
            this.$bvModal.hide('posOfferAuth')
            this.onclickApplyOffer(this.tempSelectedOffer);
          }
        }
      },
    getOfferDescription(offer, moreInfo = false) {
      let text = ``;
      if(offer.offer_type_id == 9) {
        if(moreInfo) {
          let offerCondition = offer.oc_max_no_of_ticket_per_transaction || '';
          if(offerCondition) {
          text += `Max Apply limit ${offerCondition}`
          }
        } else {
          text += `Buy ${offer.oc_buy_no_of_ticket} Ticket @ ${offer.oc_discount_value} Each.`
          let FNB_Criteria = []
          if(offer.oc_is_combo_with_fnb  == 'Y' && offer.fnb_group_data) {
            try {
              FNB_Criteria = offer.fnb_group_data ? JSON.parse(offer.fnb_group_data) : []
            } catch (err) {
              console.log('Error', err);
              FNB_Criteria = offer.fnb_group_data ? offer.fnb_group_data : []
            }
            if(FNB_Criteria.length > 0) {
            text += " Also Get" + FNB_Criteria.map(y => y.oc_buy_no_of_item + "x -" + y.selectedFnbItem.item_name + " @ " + this.currFormat(y.oc_fnb_at_price) + " Each.").join(", ")
            }
          } 
        }
        return text;
      } else if(offer.offer_type_id == 10) {
        if(moreInfo) {
          let offerCondition = offer.oc_max_no_of_ticket_per_transaction || '';
          if(offerCondition) {
            text += `Max Apply limit ${offerCondition}`
          }
        } else {
          text += `Buy ${offer.oc_buy_no_of_ticket} Ticket and Get ${offer.oc_discount_value_is_percentage == 'Y' ? '' : 'Flat'} ${offer.oc_discount_value} ${offer.oc_discount_value_is_percentage == 'Y' ? '%' : ''} OFF on another ticket.`
          return text;
        }
      }
    },
    getCurrencyCode: function() {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id:
          this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
          } else {
            // Show Error Message:
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    validateOfferNApply(offer) {},
    onclickApplyOffer(OffersItem) {
      console.log(' onclickApplyOffer OffersItem', OffersItem);
      if(OffersItem.hasOwnProperty('is_employee_offer') && OffersItem.is_employee_offer == 'Y') {
        this.tempSelectedOffer = _.cloneDeep(OffersItem);
        if(!this.employeeDetailsAuth) {
          this.onResetEmployeeDetails();
          console.log('CCLIKED posOfferAuth');
          this.$bvModal.hide('promoOffersPopup')
          this.$bvModal.show('posOfferAuth')
        } else {
          this.submitOffer(OffersItem)
          this.tempSelectedOffer = null;
          this.employeeDetailsAuth = false;
        }
      } else {
        this.submitOffer(OffersItem)
      }
    },
    submitOffer(OffersItem) {
      let pm_object = {
        pm_id: 12,
        pm_payment_mode: "Promotions & Offers"
      };
      let offerPaymentMode = this.paymentModes.filter((x) => x.pm_id == 12)
      if(offerPaymentMode && offerPaymentMode.length > 0) {
        pm_object = {...offerPaymentMode[0]}
      }
      this.$store.dispatch("setPaymentMode", pm_object);
      if (this.type == "pos") {
        this.applyOffersHandler({
          event: null,
          offer: OffersItem,
          offerFor: "offersAndPromotions",
          booking_source_id: 1
        });
      } else if (this.type == "BOXFNB") {
        this.applyBoxOfficeFnbOffersHandler({
          event: null,
          offer: OffersItem,
          offerFor: "BoxOfficeFnbOffers"
        });
      } else if (this.type == "FNB") {
        this.applyFnbOffersHandler({
          event: null,
          offer: OffersItem,
          offerFor: "fnbOffers"
        });
      }
    },
    checkOfferType(offer) {
      let status = true;
      if (
        this.type == "pos" &&
        offer.offer_type_id == 3 &&
        offer.oc_is_combo_with_fnb == "Y"
      ) {
        status = false;
      } else if (
        this.type == "FNB" &&
        offer.offer_type_id == 3 &&
        offer.oc_is_combo_with_fnb == "N"
      ) {
        status = false;
      } else if (
        this.type == "FNB" &&
        offer.offer_redeem_at_concession == "N"
      ) {
        status = false;
      } else if (this.type == "pos" && offer.offer_redeem_at_boxoffice == "N") {
        status = false;
      } else if(this.type == "BOXFNB" && offer.offer_redeem_at_boxoffice == "N") {
        status = false;
      }

      return status;
    },
    onClickAddCustomer(offer) {
      this.selectOffer = _.cloneDeep(offer);
      this.$bvModal.show("addcustmodal1");
    },
    onCallback(event) {
      console.log("get callback response == test == ", event);
      // this.onclickApplyOffer(this.selectOffer);
    }
  }
};
</script>
<style>
.disbled-section {
  cursor: not-allowed;
  opacity: 0.4;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/PromoOffersPopup.vue